export default {
  ASSET: {
    qrContent: "_id",
    qrLabel: "assetName",
  },
  USERS: {
    qrContent: "_id",
    qrLabel: "fullName",
  },
};
